import React, { useState, useEffect } from 'react';
import getUrlParams from '../elements/getUrlParams';
import axios from 'axios';
import config from '../../config/environment';
import './publicOrderHistory.css';
import '../../styles/table.admin.css';

export default function PublicOrderHistory() {
    const [state, setState] = useState({
        ordersArray: [],
        userLabel: null,
        totalProfit: null
    });

    useEffect(() => {
        const main = async () => {
            const urlParamsObj = getUrlParams();

            await axios.get(config.backendUrl + '/order/public-history-by-user?userKey=' + urlParamsObj.userKey)
                .then(response => {
                    setState(() => { return (response.data); });
                })
                .catch(error => {
                    console.log(error.message);
                    console.log(error.response.data.message);
                    console.log(error);
                    alert(error.response.data.message);
                });
        };
        main();
    }, []);

    const renderBasicInfo = () => {
        return (
            <div className="publicOrderHistory__basicInfo_wrapper">
                {state.userLabel ? <div className="publicOrderHistory__basicInfo"><span className="publicOrderHistory__basicInfo_label">User:</span> {state.userLabel}</div> : null}
                {state.totalProfit ? <div className="publicOrderHistory__basicInfo"><span className="publicOrderHistory__basicInfo_label">Total profit:</span> {state.totalProfit}</div> : null}
            </div>
        )
    };

    const renderTable = () => {
        if (!state.ordersArray.length) {
            return (<div className="publicOrderHistory__table_wrapper"></div>);
        }

        let isRenderProfit = false;
        let isRenderExternalId = false;

        state.ordersArray.map(orderInfo => {
            if (!isRenderProfit && orderInfo.profit) { isRenderProfit = true; }
            if (!isRenderExternalId && orderInfo.externalId) { isRenderExternalId = true; }
        });

        return (
            <div className="publicOrderHistory__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order hash</th>
                            { isRenderExternalId ? <th>External ID</th> : null }
                            <th>Exchange way</th>
                            <th>In amount</th>
                            <th>Withdrawn amount</th>
                            { isRenderProfit ? <th>Profit</th> : null }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state.ordersArray.map((orderInfo, index) => {
                                return (
                                    <tr>
                                        <td>{orderInfo.date}</td>
                                        <td>{orderInfo.orderHash}</td>
                                        { isRenderExternalId ? <td>{orderInfo.externalId || '–'}</td> : null }
                                        <td>{orderInfo.inCurrencyCode + ' >> ' + orderInfo.outCurrencyCode}</td>
                                        <td>{orderInfo.inAmount + ' ' + orderInfo.inCurrencyCode}</td>
                                        <td>{orderInfo.withdrawnAmount + ' ' + orderInfo.outCurrencyCode}</td>
                                        { isRenderProfit ? <td>{orderInfo.profit || '–'}</td> : null }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <>
            {renderBasicInfo()}
            {renderTable()}
        </>
    );
}